import {useWatch} from "react-hook-form";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";

export default function useMapImportColumnFields(headerKey) {
    const {formRenderMethods: {control}, getField} = useFormRenderContext();
    const value = useWatch({
        control,
        name: headerKey,
        defaultValue: getField(headerKey)?.value,
    });

    return {
        isMapped: !!value,
    }
}
